import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class ProjectService extends RLBaseService {
    static $inject = ["$resource"];
    constructor(private $resource: ng.resource.IResourceService) {
        super($resource);
    }

    deleteProject(projectID: string) {
        var data = {
            entityID: projectID
        };
        return this.toRLService<void>("/api/project/deleteproject").post(data).$promise;
    }

    getContactsForEntity(entityID: string) {
        var data = {
            entityID: entityID
        };
        return this.toRLService<Models.IContactParty>("/api/contact/GetContacts", {}).query(data).$promise;
    }

    getProjectInventory(projectID: string) {
        var data = {
            projectID: projectID
        };
        return this.toRLService<Models.IEntityRelationshipPair>("/api/project/getprojectinventory").query(data).$promise;
    }

    addProjectInventory(projectID: string, assetIDs: number[]) {
        var data = {
            projectID: projectID,
            assetIDs: assetIDs
        };
        return this.toRLService<string>("/api/project/addprojectinventory").postArray(data).$promise;
    }

    removeProjectInventory(projectID: string, relRecID: number) {
        var data = {
            projectID: projectID,
            relRecID: relRecID
        };
        return this.toRLService<boolean>("/api/project/removeprojectinventory").post(data).$promise;
    }
    deleteProjectAttachment(projectID: number, attachmentID: number) {
        var data = {
            projectID: projectID,
            attachmentID: attachmentID
        };
        return this.toRLService<void>("/api/project/deleteprojectattachment").post(data).$promise;
    }
}